// extracted by mini-css-extract-plugin
export default {"root":"ThankYou_root__tc22s","section":"ThankYou_section__Snk7k","bold":"ThankYou_bold__G6eUc"};